import { Component, ReactNode } from 'react';
import { ErrorService } from '../../services/errorService';

interface Props {
  children: ReactNode;
  fallback?: ({ error }: { error: Error }) => ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    ErrorService.handle(error, {
      severity: 'high',
      context: { errorInfo }
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ? 
        this.props.fallback({ error: this.state.error! }) : 
        <div className="text-red-600">Something went wrong</div>;
    }

    return this.props.children;
  }
} 